import { render, staticRenderFns } from "./JobDepartment.vue?vue&type=template&id=54a7092f&scoped=true"
import script from "./JobDepartment.vue?vue&type=script&lang=js"
export * from "./JobDepartment.vue?vue&type=script&lang=js"
import style0 from "./JobDepartment.vue?vue&type=style&index=0&id=54a7092f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a7092f",
  null
  
)

export default component.exports